import ClassIcon from 'Assets/icons/classes.svg'
import { PanelHeader } from 'Components/common/TaskPanelHeader/TaskPanelHeader'
import { ClassAnnotation, ClassItem } from 'Types/Classes.types'
import styles from './Classes.module.less'
import { ClassesBody } from 'Components/tasks/Classes/ClassesBody'

export type ClassesPropsType = {
    classes: ClassItem[]
    setClassVisibility: (id: string, isVisible: boolean) => void
    setClassFocus: (id: string, isFocused: boolean) => void
    setActiveClass: (id: string) => void
    getActiveClass: () => string | null
    getAnnotationList: () => ClassAnnotation[]
}

export const Classes = (props: ClassesPropsType) => {
    return (
        <div className={styles['classes-container']} data-testid="classes-container">
            <PanelHeader title={'Classes'} actionButtons={[]} logo={ClassIcon} />
            <ClassesBody {...props} />
        </div>
    )
}
